/* eslint-disable @typescript-eslint/no-explicit-any */
import { BaseColumnCheckbox, Colors } from '@gripp/shared-ui';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { Platform, StyleSheet, Text } from 'react-native';

export const useAccountAssetColumns = () => {
  const { t } = useTranslation();
  const columnHelper = createColumnHelper();

  const columns: ColumnDef<unknown, never>[] = [
    columnHelper.accessor('selected', {
      cell: BaseColumnCheckbox.checkbox,
      header: BaseColumnCheckbox.checkboxHeader,
      meta: { style: styles.checkboxCell },
    }),
    columnHelper.accessor('name', {
      cell: (info) => (
        <Text style={[styles.cellText, styles.name]}>{info.getValue()}</Text>
      ),
      header: () => t('assets.list.name'),
      meta: { style: styles.cell },
    }),
    columnHelper.accessor('description', {
      cell: (info) => (
        <Text style={[styles.cellText, styles.description]}>
          {info.getValue()}
        </Text>
      ),
      header: () => t('assets.list.description'),
      meta: { style: styles.cell },
    }),
  ];

  return columns;
};

const styles = StyleSheet.create({
  cell: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    overflow: 'hidden',
    paddingVertical: 4,
    ...Platform.select({
      web: {
        height: 50,
        paddingRight: 16,
      },
      default: {
        height: 68,
        paddingRight: 12,
      },
    }),
  },
  checkboxCell: {
    maxWidth: 50,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  name: {
    color: Colors.black,
  },
  description: {
    color: Colors.grayText,
  },
  cellText: {
    fontSize: 16,
    lineHeight: 17,
    ...Platform.select({
      web: {
        fontWeight: '500',
        flexWrap: 'nowrap',
      },
      default: {
        fontWeight: '400',
        flexWrap: 'wrap',
      },
    }),
  },
});
